import EmiCalculator from "../layout/emiCalculator";
import PageLayout from "./PageLayout";

const EMICalculatorPage = () => {
  return (
    <PageLayout sx={{ px: 0, py: 0 }}>
      <EmiCalculator />
    </PageLayout>
  );
};

export default EMICalculatorPage;
